import * as React from 'react';

class WarningSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 24 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon warning-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M23.725 19.2123L13.775 1.05234C13.5908 0.732463 13.3256 0.466768 13.0061 0.282021C12.6866 0.0972735 12.324 1.92568e-07 11.955 1.92568e-07C11.5859 1.92568e-07 11.2233 0.0972735 10.9038 0.282021C10.5843 0.466768 10.3191 0.732463 10.135 1.05234L0.184955 19.2123C0.0437418 19.5175 -0.0182691 19.8533 0.00465392 20.1887C0.0275769 20.5241 0.134694 20.8484 0.316104 21.1315C0.497513 21.4145 0.74736 21.6473 1.04255 21.8083C1.33774 21.9692 1.66874 22.0532 2.00496 22.0523H21.905C22.2412 22.0532 22.5722 21.9692 22.8674 21.8083C23.1625 21.6473 23.4124 21.4145 23.5938 21.1315C23.7752 20.8484 23.8823 20.5241 23.9053 20.1887C23.9282 19.8533 23.8662 19.5175 23.725 19.2123ZM10.955 6.05234C10.955 5.78712 11.0603 5.53276 11.2478 5.34523C11.4354 5.15769 11.6897 5.05234 11.955 5.05234C12.2202 5.05234 12.4745 5.15769 12.6621 5.34523C12.8496 5.53276 12.955 5.78712 12.955 6.05234V13.0523C12.955 13.3176 12.8496 13.5719 12.6621 13.7594C12.4745 13.947 12.2202 14.0523 11.955 14.0523C11.6897 14.0523 11.4354 13.947 11.2478 13.7594C11.0603 13.5719 10.955 13.3176 10.955 13.0523V6.05234ZM11.955 19.0523C11.6583 19.0523 11.3683 18.9644 11.1216 18.7995C10.8749 18.6347 10.6827 18.4004 10.5691 18.1264C10.4556 17.8523 10.4259 17.5507 10.4838 17.2597C10.5417 16.9687 10.6845 16.7015 10.8943 16.4917C11.1041 16.2819 11.3713 16.139 11.6623 16.0812C11.9533 16.0233 12.2549 16.053 12.529 16.1665C12.8031 16.28 13.0373 16.4723 13.2022 16.719C13.367 16.9657 13.455 17.2557 13.455 17.5523C13.455 17.9502 13.2969 18.3317 13.0156 18.613C12.7343 18.8943 12.3528 19.0523 11.955 19.0523Z"
          fill="#EA1C0A"
        />
      </svg>
    );
  }
}

export default WarningSvg;
